import { render, staticRenderFns } from "./SchoolLeaveEntitlementTable.vue?vue&type=template&id=7a78d79a&scoped=true&"
import script from "./SchoolLeaveEntitlementTable.vue?vue&type=script&lang=js&"
export * from "./SchoolLeaveEntitlementTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a78d79a",
  null
  
)

export default component.exports